import * as React from 'react'
import Copyright from 'components/Copyright/Copyright'
import { APP_NAME, APP_WEBSITE_URL_BASE, CONTACT_CONEKTA } from 'utils/constants'
import { useTranslation } from 'react-i18next'

const T_ROOT = 'pages.view404'
const { support_email, website_url } = CONTACT_CONEKTA

const Footer = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      <div className='Footer__content--left'>
        <Copyright hideCopyRightText />
        <p className='Footer__website'>
          <a href={`${APP_WEBSITE_URL_BASE[APP_NAME.panel]}`} rel='noreferrer' target='_blank'>
            {website_url}
          </a>
        </p>
      </div>

      <div className='Footer__content--right'>
        <p className='Footer__personalized-help'>{t(`${T_ROOT}.needPersonalizedHelp`)}</p>
        <p className='Footer__support-email'>
          <a href={`mailto:${support_email}`}>{support_email}</a>
        </p>
      </div>
    </>
  )
}

export default Footer
